<template>
  <div class="user-page">
    <div class="user-box">
      <div class="user-sidebar">
        <div class="user-sidebar-title">
          <img src="@/assets/icon_user_title.png">
          <span>欢迎参赛</span>
        </div>
        <div class="user-menu">
          <div class="user-li" @click="goInfo()">
            <img src="@/assets/icon_user_info_unselect.png">
            <span>个人信息</span>
          </div>
          <div class="user-li menu-activate" @click="goWork()">
            <img src="@/assets/icon_user_work_selected.png">
            <span>作品管理</span>
          </div>
          <div class="user-li" @click="goCert()">
            <img src="@/assets/icon_user_cert_unselect.png">
            <span>证书查询</span>
          </div>
        </div>
      </div>
      <div class="user-content">
        <div class="user-avatar-box">
          <div class="user-avatar">
            <label for="def_input">
              <img :src="avatar || require('@/assets/default_av.png')" alt=" ">
            </label>
          </div>
          <span>{{ realname }}</span>
        </div>
        <div class="user-form">
          <div class="user-form-item">
              <div class="item-required">*</div>
              <div class="item-label">赛&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;道</div>
              <div class="item-input">
                <el-select v-model="race" filterable remote placeholder="" @change="changeRaceFn()">
                  <el-option
                      v-for="item in arrRace"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
          </div>
          <div class="user-form-item">
              <div class="item-required">*</div>
              <div class="item-label">类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别</div>
              <div class="item-input">
                <el-select v-model="topic" filterable remote placeholder="" @change="changeTopicFn">
                  <el-option
                      v-for="item in arrRaceTopic"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
          </div>
          <div class="user-form-item user-form-item-long">
              <div class="item-required">*</div>
              <div class="item-label">作品名称</div>
              <div class="item-input"><input type="text" placeholder="" autocomplete="new-title" v-model="title"></div>
          </div>
          <div class="user-form-item">
              <div class="item-required">*</div>
              <div class="item-label">院校名称</div>
              <div class="item-input">
                <el-select v-model="company" filterable remote placeholder="" :remote-method="searchSchool">
                    <el-option
                        v-for="item in arrSchool"
                        :key="item"
                        :label="item"
                        :value="item">
                    </el-option>
                  </el-select>
              </div>
          </div>
          <div class="user-form-item">
              <div class="item-required">*</div>
              <div class="item-label">作品类型</div>
              <div class="item-input">
                <el-select v-model="cate" filterable remote placeholder="">
                  <el-option
                      v-for="item in arrCate"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
          </div>
          <div class="user-form-item user-form-item-small">
              <div class="item-required">*</div>
              <div class="item-label">参赛作者1</div>
              <div class="item-input"><input type="text" placeholder="" autocomplete="new-author1" v-model="author1"></div>
          </div>
          <div class="user-form-item user-form-item-small">
              <div class="item-required"></div>
              <div class="item-label">参赛作者2</div>
              <div class="item-input"><input type="text" placeholder="" autocomplete="new-author2" v-model="author2"></div>
          </div>
          <div class="user-form-item user-form-item-small">
              <div class="item-required"></div>
              <div class="item-label">参赛作者3</div>
              <div class="item-input"><input type="text" placeholder="" autocomplete="new-author1" v-model="author3"></div>
          </div>
          <div class="user-form-item user-form-item-small">
              <div class="item-required"></div>
              <div class="item-label">参赛作者4</div>
              <div class="item-input"><input type="text" placeholder="" autocomplete="new-author1" v-model="author4"></div>
          </div>
          <div class="user-form-item">
              <div class="item-required">*</div>
              <div class="item-label">指导老师1</div>
              <div class="item-input"><input type="text" placeholder="" autocomplete="new-teacher_realname1" v-model="teacher_realname1"></div>
          </div>
          <div class="user-form-item">
              <div class="item-required">*</div>
              <div class="item-label">联系电话</div>
              <div class="item-input"><input type="text" placeholder="" autocomplete="new-teacher_phone1" v-model="teacher_phone1"></div>
          </div>
          <div class="user-form-item">
              <div class="item-required"></div>
              <div class="item-label">指导老师2</div>
              <div class="item-input"><input type="text" placeholder="" autocomplete="new-teacher_realname2" v-model="teacher_realname2"></div>
          </div>
          <div class="user-form-item">
              <div class="item-required"></div>
              <div class="item-label">联系电话</div>
              <div class="item-input"><input type="text" placeholder="" autocomplete="new-teacher_phone2" v-model="teacher_phone2"></div>
          </div>
          <div class="user-form-item user-form-item-textarea">
              <div class="item-required">*</div>
              <div class="item-label">作品说明</div>
              <div class="item-input">
                <textarea class="upload-document" v-model.trim="document"></textarea>
              </div>
          </div>
          <div class="user-form-item user-form-item-img">
              <div class="item-required">*</div>
              <div class="item-label">
                <div class="label-text">上传展板</div>
                <div class="label-download-box" @click="downloadDoc()">
                  <div class="download-icon"><img src="@/assets/icon_pdf.png"></div>
                  <div class="download-text">模板下载</div>
                </div>
              </div>
              <label for="def_document">
                <div class="item-input">
                  <img src="@/assets/upload_black_icon.png" class="icon-upload" v-show="board_path == '' && board_progress == 0 ">
                  <img :src="board_path_preview" class="icon-file" v-show="board_path_preview != ''">
                  <div class="item-progress" v-show="board_progress > 0 && board_progress < 99">{{ board_progress }} %</div>
                </div>
              </label>
              <input hidden type="file" accept=".jpg,.png" :id="`def_document`"  @change="uploadFile($event,'board',0)">
              <div class="item-desc">将作品文件编排于展板内，300dpi、JPG、RGB\CMYK，文件不超过10MB。展示海报将用于作品评审等场景。</div>
          </div>
          <template v-for="(item,workIndex) in arrWorkFile">
            <div class="user-form-item user-form-item-img" v-bind:key="workIndex">
                <div class="item-required">*</div>
                <div class="item-label">文件/视频/图片</div>
                <label :for="`workfile-${workIndex}`">
                  <div class="item-input">
                    <img src="@/assets/upload_black_icon.png" class="icon-upload" v-show="item.previewUrl == '' && item.progress == 0">
                    <img :src="item.previewUrl" class="icon-file" v-show="item.previewUrl != ''">
                    <div class="item-progress" v-show="item.progress > 0 && item.progress < 99">{{ item.progress }} %</div>
                  </div>
                </label>
                <input hidden type="file" accept=".jpg,.png,.mp4,.doc,.docx,.pdf" :id="`workfile-${workIndex}`"  @change="uploadFile($event,'workfile',workIndex)">
                <div class="item-desc">单幅画面限定A3大小、300dpi、JPG、RGB\CMYK、GIF，上传不超过5张，文件大小不超过10MB。视频限定Mp4格式文件不超过500MB</div>
            </div>
          </template>
          <div class="btn-save" @click="edit()" v-show="state == 1">保&nbsp;&nbsp;&nbsp;存</div>
          <div class="btn-add" @click="submit()" :class="{'can-submit':canSubmit}" v-show="state == 1">上&nbsp;&nbsp;&nbsp;传</div>
        </div>
      </div>
    </div>
    <div class="agreement-window" v-show="showAgreement">
      <div class="agreement-box">
        <div class="agreement-context">
          <div class="title">第四届中国品牌设计大赛参赛条款</div>
          <div class="work-title">作品名：{{ title }}</div>
          <div class="work-author">作者：：{{ author1 }} {{ author2 }} {{ author3 }}</div>
          <div class="context" v-html="agreement"></div>
          <div class="btn-box">
            <div class="btn-cancel" @click="closeAgreement()">取&nbsp;&nbsp;&nbsp;消</div>
            <div class="btn-confirm" @click="acceptAgreement()">同意并提交</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import $ from "jquery"
import {Warning} from "@/plugins/warning";
import {getConfigObj,getUserInfo,getRace,getRaceTopic,getSearchSchoolFilter,getMyWorksShow,editUserWorks,submitUserWorks} from "@/request/api";
import {mapGetters} from "vuex";
import { LoadingFn } from '@/plugins/loading';
const OSS = require('ali-oss')
export default {
  name: "worksEdit",
  components:{
  },
  data() {
    return {
      id:0,
      work_board_template_url: '',
      avatar: '',
      realname: '',
      race: 0,
      topic: '',
      title: '',
      company: '',
      cate: 1,
      author1: '',
      author2: '',
      author3: '',
      author4: '',
      teacher_realname1: '',
      teacher_realname2: '',
      teacher_phone1: '',
      teacher_phone2: '',
      document: '',
      board_path: '',
      board_path_preview: '',
      board_progress: 0,
      state: 1,
      arrCate:[{"id":1,"name":"图片"},{"id":2,"name":"视频"}],
      arrRace: [],
      arrRaceTopic: [],
      arrRaceTopic7: [],
      arrRaceTopic8: [],
      arrSchool: [],
      arrDocumentPath: {},
      arrWorkFile: [{"fileUrl":"","previewUrl":"","uploading":false,"progress":0}],
      uploading: false,
      agreement: "",
      showAgreement: false,
      canSubmit: false,
    }
  },
  computed: {
    ...mapGetters('infoModule',['getUserInfoObj']),
  },
  created() {
    this.getRaceTopicFn()
    this.getRaceFn()
    this.getUserInfoFn()
    this.getConfigObjFn()
    this.loadInfo()
  },
  mounted() {
    
  },
  methods: {
    loadInfo(){
      this.query = this.$route.query
      const {id} = this.$route.query

      if(id != null && id!= undefined && id!= ''){
        this.id = id;
        this.getWorkInfoFn()
      }else{
        const {topic,race} = this.$route.query
        if(race!= null && race!= undefined && race!= ''){
          this.race = Number(race);
        }
        if(topic!= null && topic!= undefined && topic!= ''){
          this.topic = Number(topic);
        }
      }
    },
    goInfo(){
      this.$router.push({name:'userAccountManage'})
    },
    goWork(){
      this.$router.push({name:'userWorks'})
    },
    goCert(){
      this.$router.push({name:'userCertificate'})
    },
    changeRaceFn(){
      this.topic = '';
      this.changeRace();
    },
    changeRace(){
      //this.topic = '';
      if(this.race == 7){
        this.arrRaceTopic = this.arrRaceTopic7;
      }else if(this.race == 8){
        this.arrRaceTopic = this.arrRaceTopic8;
      }
    },
    changeTopicFn(value){
      this.agreement = '';
      for(let i = 0; i < this.arrRaceTopic.length; i++){
        if(this.arrRaceTopic[i].id == value){
          this.agreement = this.arrRaceTopic[i].article_agreement;
        }
      }
    },
    getWorkInfoFn(){
      const requestData = {
        id: this.id,
        user_id: this.getUserInfoObj.id,
      };
      getMyWorksShow(requestData).then((res)=>{
        this.race = res.data.race;
        this.topic = res.data.topic;
        this.title = res.data.title;
        this.company = res.data.company;
        this.cate = res.data.cate;
        this.author1 = res.data.author1;
        this.author2 = res.data.author2;
        this.author3 = res.data.author3;
        this.author4 = res.data.author4;
        this.teacher_realname1 = res.data.teacher_realname1;
        this.teacher_realname2 = res.data.teacher_realname2;
        this.teacher_phone1 = res.data.teacher_phone1;
        this.teacher_phone2 = res.data.teacher_phone2;
        this.document = res.data.document;
        this.board_path = res.data.board_path;
        this.board_path_preview = res.data.board_path_url;
        this.state = res.data.state;

        this.arrWorkFile = res.data.worksFiles.map(file => ({
          fileUrl: file.works_path,
          previewUrl: file.works_path_url,
          uploading: false,
          progress: 0
        }));

        this.arrWorkFile.push({"fileUrl":"","previewUrl":"","uploading":false,"progress":0})
      
        this.canSubmit = true;
        //this.changeRace();
        this.searchSchool(this.company);

        this.changeTopicFn(this.topic);
      })
    },
    getUserInfoFn(){
      getUserInfo({}).then((res)=>{
        this.avatar = res.data.avatar;
        this.realname = res.data.realname;
      })
    },
    getConfigObjFn(){
      const requestData = {
        key: 'work_board_template;work_doc_template'
      }
      getConfigObj(requestData).then(res=>{
        this.configObj = res.data
        this.work_board_template_url = this.configObj.work_board_template.s+'?response-content-disposition=attachment;filename="展示模板.pdf"';
        // this.htmlContent = res.data[type]
        //this.agreement = this.configObj.match_agreement;
      })
    },
    getRaceFn(){
      getRace({"size":999}).then(res=>{
        this.arrRace = res.data.race;
        if(res.data.race.length > 0 && this.race == 0){
          this.race = res.data.race[0].id;
        }
      })
    },
    getRaceTopicFn(){
      getRaceTopic({"race_id":7,"size":999}).then(res=>{
        this.arrRaceTopic7 = res.data.topic;
        this.changeRace();
      })
      getRaceTopic({"race_id":8,"size":999}).then(res=>{
        this.arrRaceTopic8 = res.data.topic;
        this.changeRace();
      })
    },
    searchSchool(key){
      const requestData = {
        school: key,
      };
      getSearchSchoolFilter(requestData).then((res)=>{
        this.arrSchool = res.data;
      })
    },
    downloadDoc(){
      window.open(this.work_board_template_url);
    },
    addWorkFile(){
      this.arrWorkFile.push({"fileUrl":"","previewUrl":"","uploading":false,"progress":0})
    },
    uploadFile(e,fileType,index){
      const that = this;
      const file = e.target.value;
      let filename=file.replace(/.*(\/|\\)/, "");
      let fileExt=(/[.]/.exec(filename)) ? /[^.]+$/.exec(filename.toLowerCase()) : '';
      // console.log(fileType,this.workUploadArr[index][fileType])
      //that.$set(that.workUploadArr[fileType][index],'uploading',true)
      if(that.uploading){
        Warning.open("文件正在上传中，请等待文件上传完毕");
        return;
      }
      that.uploading = true;

      if(fileType == 'board'){
        that.$set(that.arrDocumentPath,'uploading',true)
      }else{
        that.$set(that.arrWorkFile[index],'uploading',true)
      }

      let storage = JSON.parse(window.localStorage.getItem('STORAGE'));
      console.log(storage.infoModule)
      $.ajax({
        url: process.env.VUE_APP_SERVER_URL+'/works/uploads/index',
        data:{
          suffix:fileExt[0],
          path:"works"
        },
        headers:{
          Authorization:storage.infoModule.token
        },
        async: true,
        global: false,
        type: 'POST',
        dataType: 'json',
        timeout:1000*7,
        success: function(data) {
          if (data.status === 200) {
            const client = new OSS({
              region: data.result.data.region,
              accessKeyId: data.result.data.access_key_id,
              accessKeySecret: data.result.data.access_key_secret,
              stsToken: data.result.data.security_token,
              bucket: data.result.data.bucket,
            });

            LoadingFn.open();

            client.multipartUpload(data.result.data.key, e.target.files[0], {
              // 设置上传回调。
              progress:(p) => {
                if(p>=1){
                  setTimeout(function () {
                    if(fileType == 'board'){
                      that.$set(that.arrDocumentPath,'fileUrl',data.result.data.url)
                      that.$set(that.arrWorkFile[index],'fileUrl',data.result.data.url)
                      setTimeout(function () {
                        that.$set(that.arrDocumentPath,'previewUrl',data.result.data.preview_url)
                        that.$set(that.arrDocumentPath,'uploading',false)
                        that.board_path = data.result.data.url
                        that.board_path_preview = data.result.data.preview_url
                        that.board_progress = 0;
                        Warning.success("展板文件上传成功");
                      }, 500);
                    }else{
                      that.$set(that.arrWorkFile[index],'fileUrl',data.result.data.url)
                      setTimeout(function () {
                        that.$set(that.arrWorkFile[index],'previewUrl',data.result.data.preview_url)
                        that.$set(that.arrWorkFile[index],'uploading',false)
                        that.$set(that.arrWorkFile[index],'progress',0)
                        Warning.success("作品文件上传成功（如果无法预览可以在保存后重新编辑查看）");
                        that.arrWorkFile.push({"fileUrl":"","previewUrl":"","uploading":false,"progress":0})
                      }, 1000);
                    }
                    LoadingFn.close();
                    that.uploading = false;
                  }, 500);
                }else{
                  if(fileType == 'board'){
                    //that.$set(that.arrDocumentPath,'progress',(p*100) >> 0)
                    that.board_progress = (p*100) >> 0
                  }else{
                    that.$set(that.arrWorkFile[index],'progress',(p*100) >> 0)
                  }
                }
              }
            });
          }else {
            if(fileType == 'board'){
              that.$set(that.arrDocumentPath,'fileUrl','')
              that.$set(that.arrDocumentPath,'previewUrl','')
              that.$set(that.arrDocumentPath,'uploading',false)
            }else{
              that.$set(that.arrWorkFile[index],'fileUrl','')
              that.$set(that.arrWorkFile[index],'previewUrl','')
              that.$set(that.arrWorkFile[index],'uploading',false)
            }
            Warning.open(data.msg);
            that.uploading = false;
          }
        }
      })
    },
    edit(){
      if(this.race == ''){
        Warning.open("请选择赛道");
        return;
      }
      if(this.topic == ''){
        Warning.open("请选择类别");
        return;
      }
      if(this.title == ''){
        Warning.open("请输入作品名称");
        return;
      }
      if(this.school == ''){
        Warning.open("请选择院校");
        return;
      }
      if(this.cate == ''){
        Warning.open("请选择作品类型");
        return;
      }
      if(this.author1 == ''){
        Warning.open("请输入参赛作者1的姓名");
        return;
      }
      if(this.teacher_realname1 == ''){
        Warning.open("请输入指导老师1的姓名");
        return;
      }
      if(this.teacher_phone1 == ''){
        Warning.open("请输入指导老师1的联系电话");
        return;
      }
      if(this.document == ''){
        Warning.open("请输入作品说明");
        return;
      }
      if(this.board_path == ''){
        Warning.open("请上传展板");
        return;
      }
      if(this.arrWorkFile.length == 0  || this.arrWorkFile.every(item => !item.fileUrl)){
        Warning.open("请上传作品");
        return;
      }

      let work_files = this.arrWorkFile.map(item => item.fileUrl).filter(url => url)
      let requestData = {
        "id": this.id,
        "race": this.race,
        "topic": this.topic,
        "title": this.title,
        "company": this.company,
        "cate": this.cate,
        "author1": this.author1,
        "author2": this.author2,
        "author3": this.author3,
        "author4": this.author4,  
        "teacher_realname1": this.teacher_realname1,  
        "teacher_realname2": this.teacher_realname2,
        "teacher_phone1": this.teacher_phone1,
        "teacher_phone2": this.teacher_phone2,
        "document": this.document,
        "board_path": this.board_path,
        "work_files": work_files,
      }
      editUserWorks(requestData).then((res)=>{
        this.id = res.data;
        this.canSubmit = true;
        Warning.success("保存成功");
      })
    },
    submit(){
      if(this.canSubmit == false){
        Warning.open("请先保存作品信息");
        return;
      }
      this.showAgreement = true;
    },
    closeAgreement(){
      this.showAgreement = false;
    },
    acceptAgreement(){
      this.showAgreement = false;
      
      let requestData = {
        "id": this.id,
      }
      submitUserWorks(requestData).then((res)=>{
        this.state = 2;
        Warning.success(res.msg);
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.user-page{
  width: 100%;
  .user-box{
    width: 1280px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    padding-bottom: 100px;
    background: #F6F6F6;
    display: flex;
    .user-sidebar{
      width: 320px;
      height: 560px;
      background: #fff;
      //box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      .user-sidebar-title{
        width: 260px;
        height: 56px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
        img{
          width: 56px;
          height: 56px;
          float: left;
        }
        span{
          font-size: 24px;
          font-weight: 500 ;
          color: #FF3B30;
          height: 56px;
          line-height: 56px;
          float: left;
          margin-left: 20px;
        }
      }
      .user-menu{
        width: 260px;
        height: 340px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
        .user-li{
          float: left;
          width: 260px;
          height: 65px;
          margin-bottom: 30px;
          background-color: #FFF;
          cursor: pointer;
          img{
            width: 32px;
            height: 32px;
            float: left;
            margin-left: 25px;
            margin-top: 16px
          }
          span{
            font-size: 20px;
            font-weight: 400;
            color: #696969;
            height: 65px;
            line-height: 65px;
            float: left;
            margin-left: 20px;
          }
        }
        .menu-activate{
          background-color: #FF3B30;
          span{
            color: #FFF;
          }
        }
      }
    }
    .user-content{
      width: 930px;
      margin-left: 35px;
      background: #fff;
      //box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      padding-bottom: 50px;
      .user-avatar-box{
        width: 95px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 30px;
        .user-avatar{
          height: 95px;
          width: 95px;
          background: url(~@/assets/user_avatar_bg.png);
          background-size: cover;
          img{
            margin-top: 10px;
            margin-left: 10px;
            height: 72px;
            width: 72px;
            border-radius: 50%;
            overflow: hidden;
            cursor: pointer;
          }
        }
        span{
          font-size: 20px;
          font-weight: 400;
          color: #3F3F3F;
          height: 29px;
          line-height: 29px;
          text-align: center;
          display: block;
          margin-top: 10px;
        }
      }
      .user-form{
        width: 590px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 45px;
        .user-form-item{
          float: left;
          width: 280px;
          height: 33px;
          font-size: 14px;
          margin-right: 15px;
          margin-bottom: 30px;
          .item-required{
            float: left;
            color: #FF3B30;
            height: 33px;
            line-height: 33px;
            width: 10px;
          }
          .item-label{
            float: left;
            height: 33px;
            width: 70px;
            line-height: 33px;
          }
          .item-input{
            float: left;
            height: 33px;
            width: 200px;
            border-radius: 4px;
            border: 1px solid #ccc;
            & > input {
              width: 100%;
              height: 33px;
              line-height: 33px;
              font-size: 12px;
              background: transparent;
              padding-left: 10px;
              padding-right: 10px;
              border: none;
              outline: none;
              &:-webkit-autofill,
              &:-webkit-autofill:hover,
              &:-webkit-autofill:focus,
              &:-webkit-autofill:active {
                -webkit-box-shadow: 0 0 0 30px transparent inset !important;
                box-shadow: 0 0 0 30px transparent inset !important;
                background-color: transparent !important;
                background-image: none !important;
                transition: background-color 5000s ease-in-out 0s;
              }
            }
          }
        }
        .user-form-item-small{
          width: 145px;
          margin-right: 0px;
          .item-input{
            width: 65px;
          }
        }
        .user-form-item-long{
          width: 580px;
          .item-input{
            width: 495px;
          }
        }
        .user-form-item-textarea{
          width: 580px;
          height: 130px;
          .item-input{
            width: 495px;
            height: 130px;
            & > textarea {
              width: 495px;
              height: 120px;
              padding: 10px;
            }
          }
        }
        .user-form-item-img{
          height: 240px;
          .item-input{
            height: 200px;
            margin-bottom: 10px;
            position: relative;
            cursor: pointer;
            img{
              height: 200px;
              width: 200px;
              cursor: pointer;
            }
            .icon-upload{
              position: absolute;
              height: 60px;
              width: 60px;
              margin-top: 65px;
              margin-left: 65px;
              z-index: 1;
            }
            .icon-file{
              position: absolute;
              z-index: 10;
              top: 0;
              left: 0;
            }
            .icon-file-pdf{
              position: absolute;
              z-index: 10;
              top: 50px;
              left: 50px;
              height: 100px;
              width: 100px;
            }
            .item-progress{
              position: absolute;
              z-index: 10;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .item-desc{
            margin-left: 80px;
            font-size: 11px;
            color: #939393;
          }
          .item-label{
            height: 240px;
            .label-text{
              width: 100%;
            }
            .label-download-box{
              width: 100%;
              height: 30px;
              cursor: pointer;
              .download-icon{
                float: left;
                height: 30px;
                width: 30px;
                margin-top: 2px;
                img{
                  height: 30px;
                  width: 30px;
                }
              }
              .download-text{
                float: left;
                height: 30px;
                width: 40px;
                font-size: 11px;
                font-weight: 400;
                color: #FF3B30;
                line-height: 18px;
                letter-spacing: 3px;
              }
            }
          }
        }
        .btn-save{
          float: left;
          clear: both;
          width: 130px;
          height: 33px;
          margin-left: 80px;
          margin-top: 30px;
          margin-bottom: 50px;
          line-height: 33px;
          font-size: 12px;
          text-align: center;
          color: #FFFFFF;
          cursor: pointer;
          border-radius: 4px;
          background: #FF3B30;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
        }
        .btn-add{
          float: left;
          width: 130px;
          height: 33px;
          margin-left: 30px;
          margin-top: 30px;
          margin-bottom: 50px;
          line-height: 33px;
          font-size: 12px;
          text-align: center;
          color: #000000;
          cursor: pointer;
          border-radius: 4px;
          background: #D3D3D3;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
        }
        .can-submit{
          cursor: pointer;
          color: #FFFFFF;
          background: #FF3B30;
        }
      }
    }
  }
  .agreement-window{
    width: 100%;
    height: 1680px;
    background: rgba(0,0,0,0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 50;
    .agreement-box{
      width: 740px;
      height: 815px;
      margin-left: 520px;
      margin-top: 550px;
      background: #fff;
      overflow: hidden;
      .agreement-context{
        width: 540px;
        height: 615px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        .title{
          font-size: 24px;
          font-weight: 600;
          text-align: center;
          letter-spacing: 5px;
          color: #3F3F3F;
        }
        .work-title{
          margin-top: 24px;
          font-size: 14px;
          font-weight: 400;
          color: #3F3F3F;
        }
        .work-author{
          font-size: 14px;
          font-weight: 400;
          color: #3F3F3F;
        }
        .context{
          width: 100%;
          height: 420px;
          margin-top: 25px;
          font-size: 12px;
          font-weight: 400;
        }
        .btn-box{
          width: 400px;
          margin-left: auto;
          margin-right: auto;
          height: 33px;
          margin-top: 50px;
          overflow: hidden;
          .btn-cancel{
            float: left;
            width: 130px;
            height: 33px;
            margin-left: 30px;
            margin-bottom: 50px;
            line-height: 33px;
            font-size: 12px;
            text-align: center;
            color: #000000;
            border-radius: 4px;
            background: #D3D3D3;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
          }
          .btn-confirm{
            float: right;
            width: 130px;
            height: 33px;
            margin-left: 80px;
            margin-bottom: 50px;
            line-height: 33px;
            font-size: 12px;
            text-align: center;
            color: #FFFFFF;
            cursor: pointer;
            border-radius: 4px;
            background: #FF3B30;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
          }
        }
      }
    }
  }
}
</style>
<style>
.el-input__inner{
  height: 31px;
  line-height: 31px;
  border: none;
}
.el-input__suffix{
  height: 12px;
  width: 12px;
  margin-top: 10px;
  margin-right: 10px;
  background: url(~@/assets/icon_select_arrow.png) no-repeat;
  background-size: cover;
}
</style>
